const isDealerDotComImage = (uri) => uri.includes('dealer.com');

const hasExistingImpolicyParam = (uri) => uri.includes('impolicy=');

export default function imageResizer(
	threeUpDisplay,
	width,
	uri,
	threeUpRatio = 1
) {
	if (!uri || !isDealerDotComImage(uri) || hasExistingImpolicyParam(uri)) {
		return uri;
	}

	let resizeWidth;

	// Divide the width by 3 when the carousel is displaying 3 images
	const imageWidth = threeUpDisplay ? (width / 3) * threeUpRatio : width;

	// Set breakpoints so that we're only caching a limited # of image sizes
	switch (true) {
		case imageWidth <= 320:
			resizeWidth = 320; // iPhone 5
			break;
		case imageWidth <= 414:
			resizeWidth = 414; // iPhone 6/7/8 Plus
			break;
		case imageWidth <= 768:
			resizeWidth = 768; // iPad
			break;
		default:
			resizeWidth = 1024;
	}

	return `${uri}?impolicy=resize&w=${resizeWidth}`;
}
